import React from "react";
import {
	List,
	Datagrid,
	TextField,
	DeleteButton,
	EditButton,
	ChipField,
	DateInput,
	DateField,
	ReferenceField,
	Filter,
	SelectInput,
	ReferenceArrayInput,
	SelectArrayInput,
	ReferenceInput,
	SelectField,
	FunctionField
} from "react-admin";
import moment from "moment";
import { typeFacilityBooking } from "../../constant/TypeFacilityBooking";
import { SUPERADMIN } from "../../constant/TypeRole";
import Actions from "../Actions";
import { unparse as convertToCSV } from "papaparse/papaparse.min";

const FacilityBookingFilter = props => {
	const role = localStorage.getItem("role");
	const project = JSON.parse(localStorage.getItem("project"));
	const filter = role ? (role === SUPERADMIN ? {} : { _id: project }) : {};
	return (
		<Filter {...props}>
			<DateInput source="createdAt_lte" label="วันที่จองถึงวันที่" alwaysOn/>
			<DateInput source="createdAt_gte" label="วันที่จองตั้งแต่วันที่" alwaysOn/>
			<ReferenceInput source="facility" reference="facilities">
				<SelectInput optionText="name" />
			</ReferenceInput>
			<SelectInput source="status" label="สถานะ" choices={typeFacilityBooking} />
			<ReferenceArrayInput
				alwaysOn
				style={{ minWidth: "200px" }}
				label="Project"
				source="project"
				reference="project"
				filter={filter}
			>
				<SelectArrayInput optionText="name" />
			</ReferenceArrayInput>
		</Filter>
	);
};

const FacilityUseTime = ({ record, ...rest }) =>{
	return(
		record 
			? 
			<ReferenceField linkType={false} source="facility"
				reference="facilities"
				record={record}
				{...rest}
			>
				<FunctionField render={facility => `${moment(record.booking_date).format("HH:mm")} - ${moment(record.booking_date).add(facility.time,"minute").format("HH:mm")}`} />
			</ReferenceField>
			: null
	);};

export const FacilityBookingList = props => {
	const role = localStorage.getItem("role");
	const project = JSON.parse(localStorage.getItem("project"));
	const filter = role ? (role === SUPERADMIN ? {} : { project }) : { project };
	return (
		<List
			{...props}
			title="facilitybooking.facilitybooking"
			bulkActions={false}
			filters={<FacilityBookingFilter />}
			filterDefaultValues={filter}
			actions={<Actions isExport />}
			sort={{ field: "createdAt", order: "DESC" }}
			exporter={exporter}
		>
			<Datagrid>
				<div />
				<ReferenceField
					linkType={false}
					source="facility"
					reference="facilities"
				>
					<TextField source="name" />
				</ReferenceField>

				<ReferenceField linkType={false} source="user" reference="user">
					<TextField source="email" />
				</ReferenceField>
				<ReferenceField linkType={false} source="room" reference="room">
					<TextField source="name" />
				</ReferenceField>
				<DateField source="booking_date" showTime locales="th-TH"
					label="วันที่เข้าใช้งาน"
					options={{
						day: "numeric",
						month: "short",
						year: "numeric",
						hour: "numeric",
						minute: "numeric"
					}} />
				<DateField
					label="วันที่จอง"
					source="createdAt"
					locales="th-TH"
					options={{
						day: "numeric",
						month: "short",
						year: "numeric",
						hour: "numeric",
						minute: "numeric"
					}}
				/>
				<FacilityUseTime label="เวลาใช้งาน"/>
				<ReferenceField linkType={false} source="project" reference="project">
					<ChipField source="name" />
				</ReferenceField>
				<SelectField
					source="status"
					label="สถานะ"
					optionText={<ChipField source="name" />}
					choices={typeFacilityBooking}
				/>
				{/* <TextField source="description" /> */}
				<EditButton />
				<DeleteButton />
			</Datagrid>
		</List>
	);
};


const exporter = (records, fetchRelatedRecords) => {
	Promise.all(records.map(async (record) => {
		let newRecord = {};
		let repairStatus = typeFacilityBooking.find(x => x.id === record.status).name;
		await fetchRelatedRecords(records, "facility", "facilities").then(res => { newRecord = { ...newRecord, facility: res[record.facility].name }; });
		await fetchRelatedRecords(records, "project", "project").then(res => { newRecord = { ...newRecord, project: res[record.project].name }; });
		// await fetchRelatedRecords(records, "type_data", "repairtypedata").then(res => { newRecord = { ...newRecord, type_data: res[record.type_data].name }; });
		// await fetchRelatedRecords(records, "type", "repairtype").then(res => { newRecord = { ...newRecord, type: res[record.type].name }; });
		await fetchRelatedRecords(records, "user", "user").then(res => { newRecord = { ...newRecord, user: res[record.user].email }; });
		await fetchRelatedRecords(records, "room", "room").then(res => { newRecord = { ...newRecord, room: res[record.room].name, room_type: res[record.room].type }; });
		return {
			...newRecord,
			// ticket_no: record.ticket_no,
			// description: record.description,
			status: repairStatus,
			createdAt: moment(record.createdAt).format("YYYY-MM-DD HH:mm:ss"),
			booking_date: moment(record.booking_date).format("YYYY-MM-DD HH:mm:ss"),
			closed_date: record.closed_date ? moment(record.closed_date).format("YYYY-MM-DD HH:mm:ss") : ""
		};
	})).then(data => {
		const csv = convertToCSV({
			data,
			fields: ["facility", "project", "user", "room", "room_type", "status", "createdAt", "booking_date", "closed_date"] // order fields in the export
			// fields: ["ticket_no", "type", "type_data", "status", "description", "user_inform", "room_inform", "project", "createdAt", "closed_date"] // order fields in the export
		});
		csvDownload(csv, "facility_booking");
	});
};

const csvDownload = (csv, filename) => {
	const fakeLink = document.createElement("a");
	fakeLink.style.display = "none";
	document.body.appendChild(fakeLink);
	const blob = new Blob(["\uFEFF" + csv], { type: "text/csv" });
	if (window.navigator && window.navigator.msSaveOrOpenBlob) {
		// Manage IE11+ & Edge
		window.navigator.msSaveOrOpenBlob(blob, `${filename}.csv`);
	} else {
		fakeLink.setAttribute("href", URL.createObjectURL(blob));
		fakeLink.setAttribute("download", `${filename}.csv`);
		fakeLink.click();
	}
};


// WEBPACK FOOTER //
// ./src/components/facilitybooking/FacilityBookingList.js